import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { Loader } from "../../components/CustomLoader";
import { ticketManagementServices } from "../../services/AllServices";
import errorHandler from "../../utils/errorHandler";
import { capitalize } from "../../utils/helpers";
import { IMAGE_BASE } from "../../utils/constants";

const ViewTicketDetails = ({ id, show, onHide }) => {
  const [data, setData] = useState("");
  const [loading, setLoading] = useState(true);

  const fetchTicketData = async () => {
    try {
      setLoading(true);
      const response = await ticketManagementServices.getById({ id });
      setData(response.data.data);
    } catch (error) {
      errorHandler(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTicketData();
  }, []);

  return (
    <Dialog maxWidth="md" fullWidth open={show} onClose={onHide}>
      <DialogTitle>Ticket Details</DialogTitle>
      {loading ? (
        <Loader />
      ) : (
        <DialogContent dividers>
          <Grid container spacing={3}>

            {data?.image && (
              <Grid item xs={12}>
                <Box
                  display="flex"
                  flexDirection="column"
                  alignItems="center"
                  mb={3}
                >
                  <Box
                    sx={{
                      width: 100,
                      height: 100,
                      borderRadius: "50%",
                      overflow: "hidden",
                      border: "2px solid #ccc",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      backgroundColor: "#e0e0e0",
                      fontSize: 30,
                      color: "#444",
                    }}
                  >
                    {data?.image ? (
                      <img
                        src={IMAGE_BASE + data?.image}
                        alt="Uploaded"
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                        }}
                      />
                    ) : (
                      <span></span>
                    )}
                  </Box>
                </Box>
              </Grid>

            )}

            <Grid item xs={12} md={6}>
              <Typography fontWeight="bold">Name</Typography>
              <DialogContentText>{capitalize(data?.name)}</DialogContentText>
            </Grid>

            <Grid item xs={12} md={6}>
              <Typography fontWeight="bold">Retailer Name</Typography>
              <DialogContentText>{capitalize(data?.retailerName)}</DialogContentText>
            </Grid>

            <Grid item xs={12} md={6}>
              <Typography fontWeight="bold">Ticket Amount</Typography>
              <DialogContentText>₹ {data?.ticketAmount}</DialogContentText>
            </Grid>

            <Grid item xs={12} md={6}>
              <Typography fontWeight="bold">Winning Amount</Typography>
              <DialogContentText>$ {data?.winningAmount}</DialogContentText>
            </Grid>

            <Grid item xs={12} md={6}>
              <Typography fontWeight="bold">Start Date</Typography>
              <DialogContentText>{new Date(data?.startDate).toLocaleDateString()}</DialogContentText>
            </Grid>

            <Grid item xs={12} md={6}>
              <Typography fontWeight="bold">End Date</Typography>
              <DialogContentText>{new Date(data?.endDate).toLocaleDateString()}</DialogContentText>
            </Grid>

            <Grid item xs={12} md={6}>
              <Typography fontWeight="bold">Result Date</Typography>
              <DialogContentText>{new Date(data?.resultDate).toLocaleDateString()}</DialogContentText>
            </Grid>

            <Grid item xs={12} md={6}>
              <Typography fontWeight="bold">Result Status</Typography>
              <DialogContentText>{capitalize(data?.resultStatus)}</DialogContentText>
            </Grid>

            {/* <Grid item xs={12} md={6}>
              <Typography fontWeight="bold">Created At</Typography>
              <DialogContentText>{new Date(data?.createdAt).toLocaleString()}</DialogContentText>
            </Grid>

            <Grid item xs={12} md={6}>
              <Typography fontWeight="bold">Updated At</Typography>
              <DialogContentText>{new Date(data?.updatedAt).toLocaleString()}</DialogContentText>
            </Grid> */}
          </Grid>

          <DialogActions sx={{ mt: 2 }}>
            <Button variant="outlined" onClick={onHide}>
              Close
            </Button>
          </DialogActions>
        </DialogContent>

      )}
    </Dialog>
  );
};

export default ViewTicketDetails;
